// SPDX-License-Identifier: AGPL-3.0-or-later

import styles from '@app/features/channel/components/embeds/NSFWBlurOverlay.module.css';
import {NSFWGateReason} from '@app/features/guild/state/GuildNSFWAgree';
import {MediaNSFWGateDetailsModal} from '@app/features/moderation/components/modals/MediaNSFWGateDetailsModal';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {modal} from '@app/features/ui/commands/ModalCommands';
import {Tooltip} from '@app/features/ui/tooltip/Tooltip';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type {FC, MouseEvent} from 'react';
import {useCallback} from 'react';

interface NSFWBlurOverlayProps {
	reason: NSFWGateReason;
	canReveal?: boolean;
	onReveal?: () => void;
}
export const NSFWBlurOverlay: FC<NSFWBlurOverlayProps> = observer(({reason, canReveal = false, onReveal}) => {
	const {t} = useLingui();
	const isGateReason = reason === NSFWGateReason.GEO_RESTRICTED || reason === NSFWGateReason.AGE_RESTRICTED;
	const handleOpenDetails = useCallback(
		(event: MouseEvent<HTMLButtonElement>) => {
			event.preventDefault();
			event.stopPropagation();
			if (!isGateReason) {
				return;
			}
			ModalCommands.push(modal(() => <MediaNSFWGateDetailsModal reason={reason} />));
		},
		[isGateReason, reason],
	);
	if (isGateReason) {
		return (
			<div className={styles.revealOverlay}>
				<Tooltip text={t`Click for details`} position="top">
					<button type="button" className={styles.revealButton} onClick={handleOpenDetails}>
						{t`Reveal`}
					</button>
				</Tooltip>
			</div>
		);
	}
	if (!canReveal || !onReveal) return null;
	return (
		<div className={styles.revealOverlay}>
			<Tooltip text={t`Click to reveal`} position="top">
				<button type="button" className={styles.revealButton} onClick={onReveal}>
					{t`Reveal`}
				</button>
			</Tooltip>
		</div>
	);
});
